/**
 * PROTOTYPE. Reads `?variant=` from the URL and writes it back with
 * `history.replaceState`, so a variant is shareable and survives reload
 * without teaching the route a search schema it will not keep.
 */
import { useState } from "react";

import { PROTOTYPE_VARIANTS, type PrototypeVariant } from "./PrototypeSwitcher";

function readVariant(): PrototypeVariant | null {
  if (typeof window === "undefined" || !window.location || !import.meta.env.DEV) return null;
  const raw = new URLSearchParams(window.location.search).get("variant")?.toUpperCase();
  return PROTOTYPE_VARIANTS.find((variant) => variant === raw) ?? null;
}

export function useDiagnosticsPrototypeVariant(): readonly [
  PrototypeVariant | null,
  (variant: PrototypeVariant) => void,
] {
  const [variant, setVariant] = useState<PrototypeVariant | null>(readVariant);
  const change = (next: PrototypeVariant) => {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", next);
    window.history.replaceState(window.history.state, "", url);
    setVariant(next);
  };
  return [variant, change] as const;
}
